import { cn } from '../../lib/cn';
import type { GSTRow } from '../../financialintel/framework';

type Props = { returns?: GSTRow[] };

function statusColor(status: string) {
  switch (status) {
    case 'filed': return 'bg-success-100 text-success-700 dark:bg-success-950 dark:text-success-300';
    case 'ready': return 'bg-brand-100 text-brand-700 dark:bg-brand-950 dark:text-brand-300';
    case 'reconciled': return 'bg-success-100 text-success-700 dark:bg-success-950 dark:text-success-300';
    default: return 'bg-slate-100 text-slate-600 dark:bg-slate-800 dark:text-slate-400';
  }
}

export function GSTIntelligencePanel({ returns = [] }: Props) {
  return (
    <div className="space-y-2">
      {returns.map((g) => (
        <div key={g.return} className="flex items-center justify-between gap-3 rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <div>
            <p className="text-sm font-medium">{g.return}</p>
            <p className="text-xs text-slate-500">{g.period} · Due {g.dueDate}</p>
          </div>
          <span className={cn('shrink-0 rounded-full px-2 py-0.5 text-xs font-medium capitalize', statusColor(g.status))}>
            {g.status}
          </span>
        </div>
      ))}
    </div>
  );
}
